/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PerimeterPointDto
 */
export interface PerimeterPointDto {
    /**
     * 
     * @type {number}
     * @memberof PerimeterPointDto
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof PerimeterPointDto
     */
    lng: number;
}

/**
 * Check if a given object implements the PerimeterPointDto interface.
 */
export function instanceOfPerimeterPointDto(value: object): value is PerimeterPointDto {
    if (!('lat' in value) || value['lat'] === undefined) return false;
    if (!('lng' in value) || value['lng'] === undefined) return false;
    return true;
}

export function PerimeterPointDtoFromJSON(json: any): PerimeterPointDto {
    return PerimeterPointDtoFromJSONTyped(json, false);
}

export function PerimeterPointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerimeterPointDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'],
        'lng': json['lng'],
    };
}

export function PerimeterPointDtoToJSON(json: any): PerimeterPointDto {
    return PerimeterPointDtoToJSONTyped(json, false);
}

export function PerimeterPointDtoToJSONTyped(value?: PerimeterPointDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lat': value['lat'],
        'lng': value['lng'],
    };
}

